import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

/**
 * Opération custom `POST /imports/{id}/plan/generate` : enregistre le placement + les
 * POI exclus et bascule l'import en ToDo (génération asynchrone des Place/Feature).
 * Appel : `setId(importId).save({ method: 'post', patchAttributes: { placement, excludedHandles } })`.
 */
@doc.path('/imports/{id}/plan/generate')
export default class DxfGenerateModel extends MapServiceModel {
}
